var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFarmIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.155,
    height: 31.738,
    viewBox: "0 0 29.155 31.738",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4505",
    "data-name": "Rectangle 4505",
    width: 29.155,
    height: 31.738,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9068",
    "data-name": "Group 9068",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9897",
    "data-name": "Path 9897",
    d: "M8.764,25.49A19.423,19.423,0,0,1,11.831,11.16a5.394,5.394,0,0,1,1.011-1.136s7.534.026,10.665.026c.516,7.052-4.144,14.589-14.743,15.44",
    transform: "translate(5.276 6.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9898",
    "data-name": "Path 9898",
    d: "M20.887,7.256q.163,1.191.216,2.357c-3.989,0-4.523.031-8.185.031a18.244,18.244,0,0,1,7.969-2.388",
    transform: "translate(8.052 4.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9899",
    "data-name": "Path 9899",
    d: "M20.827,8.8,18.106,4.093l-6.6-1.907L5.1,3.959,2.178,8.8V22.15h8.865l.615-2.782a11.636,11.636,0,0,1,6.808-8.191l2.36-1Z",
    transform: "translate(1.358 1.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9900",
    "data-name": "Path 9900",
    d: "M24.915,10.674,20.491,4,12.848,1.706,4.625,4.58,1.436,10.612,0,9.852,3.487,3.258,12.811,0l8.708,2.609,4.75,7.169Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmIcon);
export default __webpack_public_path__ + "static/media/farmIcon.14d4b4b5cb19764d9141867b3e049b40.svg";
export { ForwardRef as ReactComponent };